import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GradientButton from '../components/GradientButton';
import { colors } from '../theme';

export default function WrongRolePage() {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: colors.background,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        padding: '32px 24px',
        textAlign: 'center',
      }}
    >
      <img
        src="/logo-white.png"
        alt="SageTech"
        style={{ height: 48, objectFit: 'contain', marginBottom: 32 }}
      />

      <div
        style={{
          background: colors.surface,
          borderRadius: 24,
          padding: '36px 28px',
          maxWidth: 380,
          width: '100%',
        }}
      >
        <div style={{ fontSize: 64, marginBottom: 20 }}>🛠️</div>

        <h2
          style={{
            color: colors.textPrimary,
            fontSize: 22,
            fontWeight: 700,
            margin: '0 0 12px',
          }}
        >
          You're a Technician!
        </h2>

        <p
          style={{
            color: colors.textSecondary,
            fontSize: 15,
            lineHeight: 1.6,
            margin: '0 0 28px',
          }}
        >
          This portal is for customers only. To manage your jobs and earn money with SageTech,
          download the SageTech Pro app.
        </p>

        <a
          href="https://apps.apple.com/app/sagetechpro"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'none', display: 'block', marginBottom: 12 }}
        >
          <GradientButton fullWidth style={{ fontSize: 16 }}>
            📱 Download SageTech Pro
          </GradientButton>
        </a>

        <button
          onClick={handleSignOut}
          style={{
            width: '100%',
            padding: '13px',
            background: 'rgba(26,10,46,0.06)',
            border: 'none',
            borderRadius: 14,
            color: colors.textSecondary,
            fontSize: 15,
            cursor: 'pointer',
            fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          }}
        >
          Sign Out
        </button>
      </div>

      <p
        style={{
          color: colors.textTertiary,
          fontSize: 13,
          marginTop: 24,
        }}
      >
        Wrong account?{' '}
        <button
          onClick={handleSignOut}
          style={{
            background: 'none',
            border: 'none',
            color: colors.primary,
            fontSize: 13,
            cursor: 'pointer',
            fontWeight: 600,
            fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          }}
        >
          Sign in with a customer account
        </button>
      </p>
    </div>
  );
}
